import { Brick, registerBrick } from 'olympe';

export default class ShowDisabledStatusOfRejectButton extends Brick {

    /**
     * @override
     * @protected
     * @param {!BrickContext} $
     * @param {boolean} hasBPPMRequests
     * @param {boolean} hasQARequests
     * @param {string} bPPmRejectionSelectedValue
     * @param {string} qARejectionSelectedValue
     * @param {function(boolean)} setRejectButtonDisabled
     */
    update($, [hasBPPMRequests, hasQARequests, bPPmRejectionSelectedValue, qARejectionSelectedValue], [setRejectButtonDisabled]) {
        // Write your code here.
        console.log(hasBPPMRequests, hasQARequests, bPPmRejectionSelectedValue, qARejectionSelectedValue,
            "hasBPPMRequests, hasQARequests, bPPmRejectionSelectedValue, qARejectionSelectedValue")
        if (hasBPPMRequests && hasQARequests) {
            if (bPPmRejectionSelectedValue?.length > 0 || qARejectionSelectedValue?.length > 0) {
                setRejectButtonDisabled(false)
            } else {
                setRejectButtonDisabled(true)
            }
        } else if (hasBPPMRequests && !hasQARequests) {
            if (bPPmRejectionSelectedValue?.length > 0) {
                setRejectButtonDisabled(false)
            } else {
                setRejectButtonDisabled(true)
            }
        } else if (!hasBPPMRequests && hasQARequests) {
            if (qARejectionSelectedValue?.length > 0) {
                setRejectButtonDisabled(false)
            } else {
                setRejectButtonDisabled(true)
            }
        } else {
            setRejectButtonDisabled(true)
        }
    }
}

registerBrick('01982e44df8804568803', ShowDisabledStatusOfRejectButton);
